export const STORAGE_CONSENT_KEY = "tt_consent"
export const GLOBAL_COOKIE_BANNER_CLASSNAME = "show-cookiebanner"
export const PRIVACY_POLICY_URL = "https://tokenterminal.com/privacy-policy"

/**
 * Bumping this discards every stored decision and re-collects it — including
 * rejections, which fall back to the permissive default and start tracking
 * someone who had said no. Only bump when consent genuinely has to be given
 * again, not for a change of wording or layout.
 *
 * Left at 1 through the banner rewrite: accept still means tracking on and
 * reject still means tracking off, so prior decisions carry unchanged and only
 * visitors who never chose get the permissive default.
 */
export const CONSENT_VERSION = 1

export type ConsentDecision = "accepted" | "rejected"

/**
 * Where a decision was made. The banner is the only surface with a measurable
 * "opened the settings" step, so decline rate is only meaningful within
 * `banner` — segment on this rather than mixing the two.
 */
export type ConsentSource = "banner" | "account"
